import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { discountStatus } from '../../enum/discountStatus';

export const DiscountStatusSelector = ({label, onChange}) => {
    return (
        <Autocomplete
            sx={{mb: 1, mt: 1}}
            options={[
                {
                    id: discountStatus.assigned,
                    label: 'Assigned',
                },
                {
                    id: discountStatus.frozen,
                    label: 'Frozen',
                },
                {
                    id: discountStatus.burned,
                    label: 'Burned',
                },
            ]}
            fullWidth
            variant="outlined"
            size="small"
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, status) => onChange(status?.id || null)}
            getOptionLabel={status => status?.label}
            renderInput={params => <TextField {...params} variant="standard" label={label} required/>}
        />
    );
};
